import { type ThemeDefinition } from 'vuetify';

export const deesplayLight: ThemeDefinition = {
	dark: false,
	colors: {
		'background': '#FAFAF9',
		'on-background': '#0C0A09',

		'surface': '#FAFAF9',
		'on-surface': '#0C0A09',

		'primary-50': '#FFF5F0',
		'primary-100': '#FFE5D9',
		'primary-200': '#FBB391',
		'primary-300': '#EF763E',
		'primary-400': '#F06625',
		'primary-500': '#E9530D',
		'primary-600': '#D04B0C',
		'primary-700': '#B13900',
		'primary-800': '#802D06',
		'primary-900': '#561C01',
		'primary-950': '#361201',
		'primary': '#E9530D',
		'on-primary': '#FAFAF9',

		'secondary-50': '#FAFAF9',
		'secondary-100': '#F5F5F4',
		'secondary-200': '#E7E5E4',
		'secondary-300': '#D6D3D1',
		'secondary-400': '#A8A29E',
		'secondary-500': '#78716C',
		'secondary-600': '#57534E',
		'secondary-700': '#44403C',
		'secondary-800': '#292524',
		'secondary-900': '#1C1917',
		'secondary-950': '#0C0A09',
		'secondary': '#0C0A09',
		'on-secondary': '#FAFAF9',

		'success-50': '#F0FDF4',
		'success-100': '#DCFCE7',
		'success-200': '#BBF7D0',
		'success-300': '#86EFAC',
		'success-400': '#4ADE80',
		'success-500': '#22C55E',
		'success-600': '#16A34A',
		'success-700': '#15803D',
		'success-800': '#166534',
		'success-900': '#14532D',
		'success-950': '#052E16',
		'success': '#22C55E',
		'on-success': '#FAFAF9',

		'warning-50': '#FFF5F0',
		'warning-100': '#FFE5D9',
		'warning-200': '#FFECBF',
		'warning-300': '#EF763E',
		'warning-400': '#F06625',
		'warning-500': '#E9530D',
		'warning-600': '#D04B0C',
		'warning-700': '#DCA100',
		'warning-800': '#802D06',
		'warning-900': '#561C01',
		'warning-950': '#361201',
		'warning': '#E9530D',
		'on-warning': '#FAFAF9',

		'error-50': '#FEF2F2',
		'error-100': '#FEE2E2',
		'error-200': '#FECACA',
		'error-300': '#FCA5A5',
		'error-400': '#F87171',
		'error-500': '#EF4444',
		'error-600': '#DC2626',
		'error-700': '#B91C1C',
		'error-800': '#991B1B',
		'error-900': '#7F1D1D',
		'error-950': '#450A0A',
		'error': '#EF4444',
		'on-error': '#FAFAF9',

		'edit-100': '#E5F0FF',
		'edit-200': '#B3D5FF',
		'edit-500': '#2155FF',
		'edit': '#2155FF',
		'on-edit': '#FAFAF9'
	},
	variables: {
		'theme-overlay-multiplier': 0,
		'theme-primary-overlay-multiplier': 0,
		'default-space': '24px',
		'border-radius': '8px'
	}
};